export enum EnumMomentoImprimirAuto{
  StatusPedido =  'status-pedido',
  NovoPedido =  'novo-pedido'
}
